export default {
  methods: {
    serviceOfOwner(service, owner) {
      return this.translate('service_of_owner', { service, owner })
    }
  }
}
